import React from "react";
var __jsx = React.createElement;
import stl from "./UsbsSliderV2.module.css";

/** @FIXME:
 * This component and UsbsSlider should be
 * unified, not unified now to make the affected area smaller
 */

var UsbsSliderV2 = function UsbsSliderV2(_ref) {
  var title = _ref.title,
    imgs = _ref.imgs;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.usbGridColumn
  }, /*#__PURE__*/React.createElement("strong", {
    className: "".concat(stl.title)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: stl.usbsSliderNew
  }, imgs.map(function (img, i) {
    return /*#__PURE__*/React.createElement("img", {
      key: i + "dx",
      width: 207,
      height: 207,
      alt: "car",
      src: img.image,
      loading: "lazy"
    });
  }))));
};
export default UsbsSliderV2;